import { render, staticRenderFns } from "./RooofAccountEdit.vue?vue&type=template&id=32b87922&scoped=true&"
import script from "./RooofAccountEdit.vue?vue&type=script&lang=js&"
export * from "./RooofAccountEdit.vue?vue&type=script&lang=js&"
import style0 from "./RooofAccountEdit.vue?vue&type=style&index=0&id=32b87922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b87922",
  null
  
)

export default component.exports